import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "valeriia_token";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem(TOKEN_KEY);
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

export const newClientId = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

export function parseError(e) {
  if (!e?.response) return { code: "network", network: true, status: 0 };
  const d = e.response.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d)) return { ...d, status: e.response.status };
  if (Array.isArray(d)) return { code: "validation", errors: d.map((x) => ({ field: (x.loc || []).slice(-1)[0], code: "invalid" })), status: e.response.status };
  return { code: typeof d === "string" ? d : "unknown", status: e.response.status };
}

export async function fetchFileBlob(fileId) {
  const r = await api.get(`/files/${fileId}/content`, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}
